import SmoothScroll from '../utils/SmoothScroll'
import Transitions from '../transitions/Transitions'
import Three from './Three'

export default class App {
	constructor() {
		if (App.instance) return App.instance

		this.smoothScroll = null
		this.transitions = null
		this.three = null

		App.instance = this
	}

	async init() {
		this.smoothScroll = new SmoothScroll()

		this.transitions = new Transitions({
			onPageView: page => this.#onPageView(page),
		})

		this.#initPage()

		this.three = new Three(document.body)
		await this.three.run()
	}

	#initPage() {}

	#onPageView(page) {
		this.smoothScroll?.reset()
		this.#initPage()
		this.three?.onPageChange(page)
	}
}
